import React, { useState, useEffect, useContext } from "react";
import { StyleSheet, ScrollView } from "react-native";
import { View } from "../../../components/shared/Themed";
import LabelBanner from "../../../components/custom/Banners/LabelBanner";
import Spinner from "../../../components/shared/Spinner";
import { getRawMaterialProductionStocksOverview } from "../../../services/stockService";

import DeviceOrientationContext from "../../../components/context/DeviceOrientationContext";
import { default as rawMaterial } from "../utils/rawMaterialStockHeaders";
import { rawMaterialStockOverviewModel } from "../../../models/reportsModel";
import { DataTableWithPagination } from "../../../components/custom/DataTable/DataTableWithPagination";
import { useSelector } from "react-redux";
import { handleTableLoader } from "../../../utils/common";
import { sortColumns } from "../../../utils/sortColumns";

export default function RawMaterialStocksOverviewReportScreen({
  route,
  navigation,
}: any) {
  const { isLargeDevice, isMediumDevice } = useContext(
    DeviceOrientationContext
  );

  const [isRefresh, setRefresh] = useState<boolean>(false);
  const { rawMaterialOverviewReport, isRawMaterialOverviewReportListLoaded } =
    useSelector((state: any) => state.reports);

  const [selected, setSelected] = useState<rawMaterialStockOverviewModel>(
    {} as unknown as rawMaterialStockOverviewModel
  );

  const [
    rawMaterialOverviewPageLevelList,
    setRawMaterialOverviewPageLevelList,
  ] = useState<Array<rawMaterialStockOverviewModel>>([]);
  const [isSearched, setIsSearched] = useState<boolean>(false);

  const [tableHeaders, setTableHeaders] = useState<
    Record<string, Record<string, string | number | boolean>>
  >(rawMaterial.headersRawMaterialOverview);

  const displayTableLoader = () => {
    handleTableLoader(true, false, setIsSearched);
  };

  const fadeTableLoader = () => {
    handleTableLoader(false, true, setIsSearched);
  };

  const onHandleSortColumn = (columnKey: string) => {
    const _sortedRawMaterialOverviewList: Array<rawMaterialStockOverviewModel> =
      sortColumns(
        rawMaterialOverviewPageLevelList,
        columnKey,
        tableHeaders,
        setTableHeaders
      );

    setRawMaterialOverviewPageLevelList(_sortedRawMaterialOverviewList);
  };

  useEffect(() => {
    let isMounted = true;

    // Avoid keep refreshing table when item is selected
    if (isMounted) {
      if (rawMaterialOverviewPageLevelList.length === 0 || isRefresh) {
        displayTableLoader();
        getRawMaterialProductionStocksOverview(tableHeaders);
      }
    }

    setTableHeaders(
      isLargeDevice
        ? rawMaterial.headersRawMaterialOverview
        : isMediumDevice
        ? rawMaterial.mediumDeviceHeadersRawMaterialOverview
        : rawMaterial.smallDeviceHeadersRawMaterialOverview
    );

    setRefresh(false);

    return () => {
      isMounted = false;
    };
  }, [selected, isRefresh]);

  useEffect(() => {
    setRawMaterialOverviewPageLevelList(rawMaterialOverviewReport);

    setTimeout(() => {
      fadeTableLoader();
    }, 2000);
  }, [rawMaterialOverviewReport]);

  return (
    <ScrollView style={{ backgroundColor: "white" }}>
      <View style={[styles.container, { backgroundColor: "#f2f2f2" }]}>
        <View
          style={[
            styles.containerContent,
            {
              width: "100%",
            },
          ]}
        >
          {isRawMaterialOverviewReportListLoaded ? (
            <View>
              <LabelBanner
                titleName={`Total Items: ${rawMaterialOverviewPageLevelList.length}`}
                childern={"a"}
              />
              <DataTableWithPagination
                headers={tableHeaders}
                rows={rawMaterialOverviewPageLevelList}
                itemsPerPage={100}
                isDataLoading={isSearched}
                useModal={false}
                isDetail={false}
                setModalVisible={() => {}}
                setSelected={setSelected}
                handleRowClick={() => {}}
                handleDeleteRow={() => {}}
                handleSortColumn={onHandleSortColumn}
              />
            </View>
          ) : (
            <View>
              <Spinner
                size="small"
                color="#74BBFF"
                styles={{ flexDirection: "row", margin: "20%" }}
              />
            </View>
          )}
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },
  containerContent: {
    flexDirection: "column",
    alignSelf: "flex-start",
    justifySelf: "flex-start",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
});
